var script = document.createElement('script');
script.src = themeData.scripts.swiper;

setTimeout(() => {
	console.log('Swiper loaded');
	document.getElementsByTagName('body')[0].appendChild(script);
}, 2000);

script.onload = () => {
	new Swiper('.most-viewed', {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		}
	});

	new Swiper('.top-posts__swiper', {
		slidesPerView: 'auto',
		pagination: {
			el: '.top-posts .swiper-pagination',
		},
		navigation: {
			nextEl: '.top-posts__navigation .swiper-button-next',
			prevEl: '.top-posts__navigation .swiper-button-prev',
		},
	});
};
